import { mask } from 'maska'

const POSTAL_CODE_MASK = '#####-###'

/** Máscara progressiva para digitação — idempotente, aceita valor já mascarado. */
export const maskPostalCodeInput = (value: string | number | null | undefined): string =>
  value === null || value === undefined ? '' : mask(String(value), POSTAL_CODE_MASK)

/** Só os dígitos — formato em que o backend armazena o CEP. */
export const postalCodeDigits = (value: string | null | undefined): string =>
  (value ?? '').replace(/\D/g, '')

/** Exibição: só formata CEP completo; devolve o valor original caso contrário. */
export const formatPostalCode = (value: string | null | undefined): string => {
  const digits = postalCodeDigits(value)
  return digits.length === 8 ? maskPostalCodeInput(digits) : (value ?? '')
}
